import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { GraphApiUtils } from '@/utils/graphApiUtils';
import { UserUtils } from '@/utils/userUtils';
import { ApiResult } from '@/enums';
import { Consts } from '@/consts';
import { GroupUtils } from '@/utils/groupUtils';
import { Groups } from '@/models/groups';

@Component({
	components: {}
})
export default class User extends Vue {
	@Prop() public groupName!: string;
	public get isVisible(): boolean {
		return true;
	}
	private isAuthenticated: boolean = false;

	@Emit("get-user-name")
	public getUserName(name: string): void { }

	@Emit("get-groups")
	public getGroups(groups: Groups): void { }

	public async created(): Promise<void> {
		try {
			// アクセストークンが有効でない場合はルートに遷移。
			if (!await GraphApiUtils.isValidAccessToken(Vue.$accessTokenInfo)) {
				this.$router.push(Consts.PATH_USER);
				return;
			}
			const accessToken: string = Vue.$accessTokenInfo.token;
			// Userの取得
			const userResult = await UserUtils.GetMe(accessToken);
			if (userResult.result !== ApiResult.Success) {
				return;
			}
			const user = userResult.value;
			if (user === null) {
				return;
			}
			localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_ID, user.id);
			localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_DISPLAYNAME, user.displayName);
			this.getUserName(user.displayName);
			// Teamの取得
			const teamsResult = await GroupUtils.GetJoinedTeams(accessToken);
			if ((teamsResult.result !== ApiResult.Success) || (teamsResult.value === null)) {
				return;
			}
			const teams: Groups = teamsResult.value;
			const groupId: string | null = localStorage.getItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID);
			if ((groupId !== null) && GroupUtils.IsPermitted(groupId)) {
				// キャッシュを利用する
				const permittedTeams: Groups = GroupUtils.GetPermittedGroups(teams);
				if (permittedTeams.value.length > 0) {
					const defaultTeam = permittedTeams.value[0];
					permittedTeams.value = [defaultTeam];
					this.getGroups(permittedTeams);
				} else {
					// メンバー外の可能性あり TODOメッセージ表示
					localStorage.removeItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID);
				}
			} else {
				const permittedTeams: Groups = GroupUtils.GetPermittedGroups(teams);
				if (permittedTeams.value.length > 0) {
					const defaultTeam = permittedTeams.value[0];
					localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID, defaultTeam.id);
					permittedTeams.value = [defaultTeam];
					this.getGroups(permittedTeams);
				} else {
					// TODOメッセージ表示
				}
			}
		} finally {
			this.isAuthenticated = true;
		}
	}

	public async mounted(): Promise<void> {
	}

	public async updated(): Promise<void> {
	}

	private updateUserHome(displayName: string, groups: Groups): void {
		this.getUserName(displayName);
		this.getGroups(groups);
	}
}
